import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../../../Translations';
import DownloadSample from '../DownloadSample';
import ImportParticipantsStore from '../Store';
import FlashError from '../../../FlashMessage/FlashError';
import { emptyFragment } from '../../../../EmptyFragment';
import DragAndDrop from './DragAndDrop';

interface Props {
  store: ImportParticipantsStore;
}

const UploadFile: React.FC<Props> = ({ store }) => {
  return (
    <div className="flex flex-col items-center px-2.5 py-20 lg:px-14">
      {store.fileSelectFailedMessage
        .map((message) => (
          <FlashError
            children={
              <p>
                <T kind={message} />
              </p>
            }
          />
        ))
        .getOrElse(emptyFragment)}
      <div className="lg:w-[55%]">
        <p className="mb-7 text-center text-base">
          <T kind="Imported participants can later be added to groups, ..." />
        </p>
        <DragAndDrop store={store} />
        <DownloadSample />
      </div>
    </div>
  );
};

export default observer(UploadFile);
